export class StickyObserver {
    constructor(container: HTMLElement) {
        const observer = new IntersectionObserver(
            ([entry]) => {
                const { boundingClientRect, rootBounds, intersectionRatio } = entry;
                let topBound = 1;
                if (!!rootBounds) {
                    topBound = rootBounds.top;
                }
                const topIntersection = boundingClientRect.top < topBound;
                container.classList.toggle('is-stuck', ((intersectionRatio < 1 && topIntersection) && intersectionRatio > 0));
            },
            {
                threshold: [1, 0],
                rootMargin: '-1px 0px 0px 0px'
            }
        );

        observer.observe(container);
    }
}